import React, { forwardRef, useReducer, useImperativeHandle, useEffect } from 'react';
import { u as useOnKeyDown_2 } from './useOnKeyDown-t-UhpB2o.js';
import { M as Modal } from './Modal-Bvh77R4C.js';
import { C as Content } from './Content-4xvXJbLn.js';
import { M as Markdown } from './Markdown-BZlKvsyD.js';

function confirmationModalReducer(state, action) {
    switch (action.type) {
        case "display":
            return Object.assign(Object.assign({}, state), { title: action.title, message: action.message, open: true, confirmLabel: action.confirmLabel, cancelLabel: action.cancelLabel || "Cancel", onConfirm: action.onConfirm, onCancel: action.onCancel });
        case "confirm":
            state.onConfirm && state.onConfirm();
            return Object.assign(Object.assign({}, state), { open: false });
        case "cancel":
            state.onCancel && state.onCancel();
            return Object.assign(Object.assign({}, state), { open: false });
        case "reset":
            return Object.assign(Object.assign({}, state), action.state);
        default:
            throw new Error();
    }
}
const ConfirmationModal = forwardRef(function ConfirmationModalInternal({ title, message, open = false, confirmLabel = "Confirm", cancelLabel = "Cancel", onConfirm, onCancel, onRequestClose, variation = "work", size, children, }, ref) {
    const [state, dispatch] = useReducer(confirmationModalReducer, {
        title,
        message,
        open: false,
        confirmLabel,
        cancelLabel,
        onConfirm,
        onCancel,
    });
    // Expose a `show` method through this component's ref.
    useImperativeHandle(ref, () => ({
        show: ({ title: newTitle, message: newMessage, confirmLabel: newConfirmLabel, cancelLabel: newCancelLabel, onConfirm: newOnConfirm, onCancel: newOnCancel, }) => {
            dispatch({
                type: "display",
                title: newTitle,
                message: newMessage,
                confirmLabel: newConfirmLabel,
                cancelLabel: newCancelLabel,
                onConfirm: newOnConfirm,
                onCancel: newOnCancel,
            });
        },
    }));
    useEffect(() => {
        dispatch({
            type: "reset",
            state: Object.assign(Object.assign({}, state), { title, message: message, confirmLabel,
                cancelLabel,
                onConfirm,
                onCancel }),
        });
    }, [title, message, confirmLabel, cancelLabel, onConfirm, onCancel]);
    useOnKeyDown_2(handleKeyboardShortcut, ["Escape", "Enter"]);
    return (React.createElement(Modal, { title: state.title, open: open || state.open, size: size, dismissible: false, primaryAction: {
            label: state.confirmLabel,
            onClick: handleAction("confirm"),
            variation: variation === "destructive" ? "destructive" : "work",
        }, secondaryAction: {
            label: state.cancelLabel,
            onClick: handleAction("cancel"),
        } }, state.message ? (React.createElement(Content, null,
        React.createElement(Markdown, { content: state.message }))) : (children)));
    function handleAction(type) {
        return () => {
            dispatch({ type });
            onRequestClose && onRequestClose();
        };
    }
    function handleKeyboardShortcut(event) {
        const { metaKey, ctrlKey, key, target } = event;
        if (!open)
            return;
        const shouldTriggerShortcut = target instanceof HTMLButtonElement ? metaKey || ctrlKey : true;
        if (!shouldTriggerShortcut)
            return;
        event.preventDefault();
        event.stopPropagation();
        switch (key) {
            case "Enter": {
                handleAction("confirm")();
                break;
            }
            case "Escape": {
                handleAction("cancel")();
                break;
            }
        }
    }
});

export { ConfirmationModal as C };
